import { render } from "./SidebarMenu.vue?vue&type=template&id=9eb728f8&scoped=true"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"

import "./SidebarMenu.vue?vue&type=style&index=0&id=9eb728f8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eb728f8"]])

export default __exports__